<template>
  <div class="container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>用户附件</span>
          <el-button-group v-if="isDel" style="float: right; padding: 3px 0">
            <el-button type="primary" size="small" @click="handleDelSaveClick">确定</el-button>
            <el-button size="small" @click="handleDelCancelClick">取消</el-button>
          </el-button-group>
          <el-button-group v-else style="float: right; padding: 3px 0">
            <el-button type="success" size="small" @click="handleUploadClick">上传</el-button>
            <el-button type="danger" size="small" @click="handleUploadDel">删除</el-button>
          </el-button-group>
      </div>
      <el-table
        :data="attachmentList"
        @selection-change="handleSelectionChange">
      >
        <el-table-column
          v-if="isDel"
          type="selection"
          width="55">
        </el-table-column>

        <el-table-column
          prop="filename"
          label="文件名"
        />

        <el-table-column
          prop="time"
          label="上传时间"
          />

        <el-table-column
          prop="remark"
          label="最新备注"
        />

        <el-table-column
          label="操作"
        >
          <template scope="scope">   
            <el-button-group>
              <el-button v-if="isAllowView(scope.row)" type="primary" size="mini" @click="handleReview(scope.row)"> 预览 </el-button>
              <el-button type="primary" size="mini" @click="handleDownload(scope.row)"> 下载 </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog 
      title="预览"
      :visible.sync="showReview"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleReviewDialogClose"
    >

      <div v-if="showPdf">
      <pdf
        ref="pdf"
        :src="fileData"
        style="width: 80%;"
        :page="currentPage"
        @num-pages="pageCount = $event"
        @page-loaded="currentPage = $event"
      />
      <el-button :disabled="currentPage === 1" @click="currentPage = currentPage - 1">上一页</el-button>
        {{ currentPage }} / {{ pageCount }}
      <el-button :disabled="currentPage === pageCount" @click="currentPage = currentPage + 1">下一页</el-button>
      </div>
      <div v-if="showImage">
        <el-image
          :src="fileData">
        </el-image>
      </div>
    </el-dialog>

    <el-dialog 
      title='上传附件'
      :visible.sync="showUpload"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleUploadDialogClose"
    >

      <el-form ref="uploadForm" :model="uploadForm" :rules="uploadRules" label-position="right" label-width="150px">
        
        <el-form-item prop="file" label="上传文件:">
          <el-upload
            ref="fileUpload"
            style="width:80%"
            action
            :http-request="handleUpload"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePreview"
            :before-remove="beforeRemove"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :file-list="fileList"
            drag
            multiple
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>

        <el-form-item prop="remark" label="备注">
          <el-input style="width:80%" size="small" v-model="uploadForm.remark" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showUpload = false">取 消</el-button>
        <el-button type="primary" @click="handleUploadSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import pdf from 'vue-pdf'
  import request from "@/api/request"
  import base64 from 'base64-arraybuffer'

  const allow = /^.+(?:doc|docx|xls|xlsx|ppt|pptx|pdf|png|jpg|jpeg|gif|bmp|txt)$/i
  const pdfReg = /^.+(?:pdf)$/i
  const imageReg = /\.(?:bmp|jpg|gif|jpeg|png)$/i
  const initUploadRules = {
    remark: [
      {
        required: true,
        message: "备注不能为空"
      }
    ]
  }

  export default {
    name: 'AttachmentUpload',
    components: { pdf },
    props: {
      data: {
        type: Number,
        default: null
      }
    },
    filters: {
    },
    data () {
      return {
        uploadRules: { ...initUploadRules },
        showDelForm: false,
        showMore: false,
        showUpload: false,
        fileList: [],
        uploadForm: {},
        isFormatFalse: false,
        viewUrl: '',
        currentPage: 1,
        pageCount: 0,
        showReview: false,
        showPdf: false,
        showImage: false,
        delAttachmentList: [],
        attachmentList: [],
        isDel: false,
        delList: [],
        fileData: null
      }
    },
    computed: {
    },
    created() {
      this.getAttachmentList()
    },
    methods: {
      getAttachmentList() {
        if (this.data) {
          request.cs.post('file_list', {range: [0, 10], sort: [{field: 'id',reverse: true}], filter: {user_id: this.data, status: 0}})
            .then(response => {
              this.attachmentList = response.data.list
            })
        }
      },
      getFile(path) {
        request.cs.post('file_get', {path: path})
          .then(r => {
            let fileType = ''
            if (imageReg.test(path)) {
              fileType = 'image/png'
            } else if (pdfReg.test(path)) {
              fileType = 'application/octet-stream'
            }
            const blob = new Blob([base64.decode(r.data)], { type: fileType })
            this.fileData = window.URL.createObjectURL(blob)
          })
      },
      handleUploadClick() {
        this.showUpload = true
      },
      handleUploadSave() {
        const p = []
        this.$refs.uploadForm.validate(async valid => {
          if (valid && this.fileList.length > 0) {
            this.fileList.forEach(f => {
              request.cs
                .post('file_create', Object.assign({ user_id: this.data, path: f.response.file, file_name: f.name }, this.uploadForm.remark ? { remark: this.uploadForm.remark } : {}))
            })

            Promise.all(p).then(() => {    
              this.fileList = []
              this.getAttachmentList()
              this.showUpload = false
            })
          }
        })
      },
      handleUpload(param) {
        let reader = new FileReader()
        reader.readAsArrayBuffer(param.file, 'utf-8')
        reader.onloadend = function (evt) {
          if (evt.target.readyState === FileReader.DONE) {
            request.cs.post('file_upload', {
              content: base64.encode(evt.target.result),
              mine_type: param.file.type
            }).then(r => {
              param.onSuccess(r.data)
            }).catch(() => {
              this.$message.error('upload failed');
            })
          }
        }.bind(this)
      },
      beforeAvatarUpload(file) {
        if (allow.test(file.name)) {
          return true
        } else {
          this.$message.error("此文件类型不可上传!");
          this.isFormatFalse = true
          return false
        }
      },
      handleSuccess(response, file, fileList) {
        this.uploadForm.file = fileList.length
        this.fileList = fileList;
      },
      beforeRemove(file, fileList) {
        // return this.$confirm(`确定移除 ${file.name}？`);
      },
      handleRemove(file, fileList) {
        this.uploadForm.file = fileList.length
        this.isFormatFalse = false
        this.fileList = fileList
      },
      handleUploadDialogClose () {
        this.uploadForm = {}
        this.$refs.uploadForm.clearValidate()
      },
      handlePreview() {
        
      },   
      handleReview(row) {
        this.getFile(row.path)
        this.showReview = true
        if (imageReg.test(row.path)) {
          this.showImage = true
        } else if (pdfReg.test(row.path)) {
          this.showPdf = true
        }
      },
      handleDownload(row) {
        request.cs.post('file_get', {path: row.path})
          .then(r => {
            let fileType = ''
            if (imageReg.test(row.path)) {
              fileType = 'image/png'
            } else {
              fileType = 'application/octet-stream'
            }

            const blob = new Blob([base64.decode(r.data)], { type: fileType })
            let link = document.createElement("a");
            link.setAttribute("download", row.filename);
            if (window.webkitURL != null) {
              link.href = window.webkitURL.createObjectURL(blob);
            } else {
              link.href = window.URL.createObjectURL(blob);
              link.style.display = "none";
              document.body.appendChild(link);
            }
            link.click();

        })
      },
      handleUploadDel() {
        this.isDel = true
      },
      handleSelectionChange(val) {
        this.delList = val
      },
      handleDelSaveClick() {
        if (this.delList.length > 0) {
          this.$confirm(`确定删除文件`)
            .then(() => {
              this.delFile()
            })
        }
        this.isDel = false
      },
      handleDelCancelClick() {
        this.delList = []
        this.isDel = false
      },
      delFile() {
        this.delList.forEach(f => {
          request.cs.post('file_status_update' , {id: f.id, status: 900})
            .then(response => {
              this.$message.success("删除成功");
              this.getAttachmentList()
            })
        })
        this.delList = []
      },
      isAllowView(row) {
        return imageReg.test(row.filename) || pdfReg.test(row.filename)
      },
      handleReviewDialogClose() {
        this.viewUrl = ''
        this.showImage = false
        this.showPdf = false
      }
    }
  }
</script>
<style scoped>
.container {
  padding: 5px;
}
.el-form-item {
  margin-bottom: 1px;
  margin-right: 10px;
}
.is-error {
  margin-bottom: 15px;
}
.el-form-item span {
  color: #000;
}
.text-wrapper {
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
  line-height: 1.5;
  display: -webkit-box;
  overflow-wrap: break-word;
}
.edit-form {
  display: flex;
  flex-flow: row wrap;
}
.health-item {
  border-radius: 2px;
  border: 1px solid #ddd6d6;
  padding: 2px 5px;
  margin-bottom: 5px;
}
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type='number'] {
  -moz-appearance: textfield !important;
}
/deep/ .el-upload {
  width: 100%;
}
/deep/ .el-upload-dragger {
  width: 100%;
}
</style>